import Link from 'next/link';

import type { MenuItem } from '../model/types';

interface PcNavigationItemProps {
  item: MenuItem;
  isHovered?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

const PcNavigationListItem = ({ item }: PcNavigationItemProps) => {
  const textClass =
    'relative text-[clamp(14px,calc(0.625vw+6px),18px)] text-secondary-black font-semibold group';

  return item.href ? (
    <Link href={item.href} target={item?.target ?? ''} rel={item?.rel ?? ''} className={textClass}>
      {item.label}
    </Link>
  ) : (
    <span className={`cursor-pointer ${textClass}`}>{item.label}</span>
  );
};

export default PcNavigationListItem;
